import PropTypes from 'prop-types';
import EverTrue from 'app';
import Decorator from 'clientDecorator';
import Address from 'apps/profile/components/templates/address';
import Email from 'apps/profile/components/templates/email';
import Phone from 'apps/profile/components/templates/phone';
import AddressMixin from 'mixins/address-mixin';
import ProfileCardSubtitle from 'apps/profile/components/profile-card-subtitle';
import FeatureStore from 'apps/layout/stores/feature-store';
import { ModalTriggerDeprecated, ModalWrapper, Icon } from '@evertrue/et-components';
import CDCModalController from 'apps/profile/components/cdc/cdc-modal-controller';
import { useFluxStore } from '@evertrue/et-flux';
import { useGlobalDrawerProvider } from 'components/drawer/context/global-drawer-context';
import { trackOutreachAction } from 'apps/outreach/utils/utils';
import { isEmpty } from '@evertrue/sdk';

const BioContactInfo = ({ contact = {}, hasHeader = true, closeModal = () => null }) => {
  const { addDrawer } = useGlobalDrawerProvider();

  const handleEmailClick = (clickedEmailAddress) => {
    closeModal();
    trackOutreachAction('open_emailer');
    addDrawer('emailer', {
      contact,
      clickedEmailAddress,
    });
  };

  const contactInfo = Decorator.Profile.getContactInfo(contact);

  const handlePhoneClick = (phoneNumber) => {
    closeModal();
    trackOutreachAction('open_dialer');
    addDrawer('dialer', {
      contact,
      phones: contactInfo.phones || [],
    });
  };

  const hasCdcProfile = useFluxStore(FeatureStore, () => FeatureStore.hasFeature('cdc_profile'));

  const handleTrack = (type) => {
    EverTrue.track.set('contact_action', {
      type,
      referrer: 'profile_section_bio_all',
    });
  };

  const renderContactInfoLabel = (label, icon) => (
    <div className="bio-info--contact-info-header clearfix">
      <Icon icon={icon} className="bio-info--contact-icon" />
      <div className="bio-info--contact-label">{label}</div>
    </div>
  );

  const renderSuggestModal = () => (
    <ModalWrapper
      width={770}
      isOpen={true}
      closeOnOutsideClick={false}
      render={({ close }) => <CDCModalController contact={contact} onClose={close} referrer="profile_contact_modal" />}
    />
  );

  let addresses = AddressMixin.getAddresses(contact);

  if (isEmpty(addresses)) addresses = [{}];
  if (contactInfo && isEmpty(contactInfo.phones)) contactInfo.phones = [{}];
  if (contactInfo && isEmpty(contactInfo.emails)) contactInfo.emails = [{}];

  return (
    <div className="bio-contact-info">
      <div className="bio-info--section">
        {hasHeader && <ProfileCardSubtitle label="Contact Info" />}

        {renderContactInfoLabel('Phone', 'call')}
        {(contactInfo?.phones || []).map((phone, i) => (
          <Phone data={phone} key={i} hideIcon={true} onClick={() => handlePhoneClick(phone.phone)} />
        ))}

        {renderContactInfoLabel('Email', 'email')}
        {(contactInfo?.emails || []).map((email, i) => (
          <Email data={email} key={i} hideIcon={true} onClick={() => handleEmailClick(email.email)} />
        ))}

        {renderContactInfoLabel('Address', 'location')}
        {addresses.map((address, i) => (
          <Address data={address} key={i} hideIcon={true} onClick={() => handleTrack('address')} />
        ))}

        {hasCdcProfile && (
          <ModalTriggerDeprecated buttonType="default" modal={renderSuggestModal()} title="Suggest Contact Update">
            <span>
              <Icon icon="upload-contact" />
              Suggest Contact Update
            </span>
          </ModalTriggerDeprecated>
        )}
      </div>
    </div>
  );
};

BioContactInfo.propTypes = {
  contact: PropTypes.object,
  hasHeader: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default BioContactInfo;
